export default __webpack_public_path__ + "static/media/airagon.4052529c.png";